import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import { qlistSelector } from '../redux/slices/questionsSlice';

/**
 * Custom hook to handle the activity item clicks.
 * @returns - the functions to handle the activity item clicks.
 */
const useActivityItem = () => {
  const navigate = useNavigate();
  const qlist = useAppSelector(qlistSelector);

  const handleQuestionActivityClick = (qid: string | undefined) => {
    if (qid) {
      navigate(`/question/${qid}`);
    }
  };

  const handleAnswerActivityClick = async (aid: string | undefined) => {
    if (!aid || !qlist) return;

    try {
      for (const q of qlist) {
        if (q?.answers?.some(a => a._id === aid)) {
          navigate(`/question/${q._id}`);
          return;
        }
      }
    } catch (error) {
      // error
    }
  };

  const handleCommentActivityClick = async (cid: string | undefined) => {
    if (!cid || !qlist) return;

    try {
      for (const q of qlist) {
        if (q?.comments?.some(c => c._id === cid)) {
          navigate(`/question/${q._id}`);
          return;
        }
        if (q?.answers) {
          for (const a of q.answers) {
            if (a.comments?.some(ac => ac._id === cid)) {
              navigate(`/question/${q._id}`);
              return;
            }
          }
        }
      }
    } catch (error) {
      // error
    }
  };

  return {
    handleQuestionActivityClick,
    handleAnswerActivityClick,
    handleCommentActivityClick,
  };
};

export default useActivityItem;
